import React from 'react';

import { AnalyticsProvider } from './analytics';
import { AppProvider } from './app';
import { AuthProvider } from './auth';
import { UserProvider } from './user';
import { ImageProvider, ImageSelectionProvider } from './image';
import { CompletionTypesProvider } from './completionTypes';
import { SubscriptionProvider } from './subscription';
import { TokensProvider } from './tokens';
import { AffiliatesProvider } from './affiliates';
import { FeatureFlagProvider } from './featureFlag';
import { CompletionsProvider } from './completions';
import { SavedContentProvider } from './savedContent';

const ContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <AnalyticsProvider>
      <AffiliatesProvider>
        <AppProvider>
          <AuthProvider>
            <UserProvider>
              <SubscriptionProvider>
                <TokensProvider>
                  <CompletionTypesProvider>
                    <FeatureFlagProvider>
                      <CompletionsProvider>
                        <ImageProvider>
                          <SavedContentProvider>
                            <ImageSelectionProvider>{children}</ImageSelectionProvider>
                          </SavedContentProvider>
                        </ImageProvider>
                      </CompletionsProvider>
                    </FeatureFlagProvider>
                  </CompletionTypesProvider>
                </TokensProvider>
              </SubscriptionProvider>
            </UserProvider>
          </AuthProvider>
        </AppProvider>
      </AffiliatesProvider>
    </AnalyticsProvider>
  );
};

export default ContextProvider;
